import { CommonModule } from '@angular/common';
import {
    TgButtons2Module,
    TgFormsModule,
    TgGridModule,
    TgModalModule,
    TgSpacingModule
} from '@trademe/tangram';
import { NgModule } from '@angular/core';
import { StartOverModalComponent } from './start-over-modal.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        TgModalModule,
        TgFormsModule,
        TgSpacingModule,
        TgButtons2Module
    ],
    declarations: [
        StartOverModalComponent
    ],
    exports: [StartOverModalComponent]
})
export class StartOverModule {
}
